import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2739">
      <div className="dark" data-id="element-2740">
        <Hero data-id="element-2741" />
      </div>
      <WhyUs data-id="element-2742" />
      <ByTheNumbers data-id="element-2743" />
      <Services data-id="element-2744" />
      <HowItWorks data-id="element-2745" />
      <FAQ data-id="element-2746" />
      <Reviews data-id="element-2747" />
      <CtaBanner data-id="element-2748" />
    </main>;
}